<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
// import logo from "@/assets/img/logo-ct-dark.png";
// import logoWhite from "@/assets/img/logo-ct.png";
import image from "@/assets/img/profile-layout-header.jpg";
import baseApiUrl from '@/configs/config';

const store = useStore();
const apiUrl = baseApiUrl.storageUrl;
const logo = ref(`${apiUrl}/logo.png`);
const useDefaultLogo = () => {
  logo.value = "/logo.png";
};
const isRTL = computed(() => store.state.argonConfig.isRTL);
const layout = computed(() => store.state.argonConfig.layout);
const sidebarType = computed(() => store.state.argonConfig.sidebarType);
const darkMode = computed(() => store.state.argonConfig.darkMode);
const route = useRoute();
const selectedModule = computed(() => {
  const slug = route.params.moduleSlug;
  if (slug === 'material-management') return 'Material Management';
  if (slug === 'manage-assets') return 'Asset Management';
  return store.state.auth.selectedModule;
});
</script>
<template>
  <div v-if="layout === 'custom'" class="position-absolute w-100 min-height-300 top-0" :style="{
    'background-image': 'url(' + image + ')',
    'background-position-y': '50%',
  }">
    <span class="mask bg-success opacity-6"></span>
  </div>
  <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-trasnparent' : 'bg-primary'}`" />

  <aside id="sidenav-main" class="sidenav navbar navbar-vertical navbar-expand-xs border-0"
    :class="` ${sidebarType} ${isRTL ? 'fixed-end me-3 rotate-caret' : 'fixed-start'} ${layout === 'landing' ? 'bg-transparent shadow-none' : ''}`">
    <template v-if="selectedModule !== 'Asset Management'">
      <div class="sidenav-header">
        <i id="iconSidenav"
          class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
          aria-hidden="true"></i>
        <router-link class="m-0 navbar-brand" :to="{ name: 'ModuleSelection' }">
          <img :src="logo" @error="useDefaultLogo" class="navbar-brand-img h-100" alt="main_logo" />
        </router-link>
      </div>
      <hr class="mt-0 horizontal dark" />
      <sidenav-list />
    </template>
  </aside>

</template>

<style scoped>
.sidenav {
  scrollbar-gutter: stable;
}

.sidenav::-webkit-scrollbar {
  width: 6px;
}

.sidenav::-webkit-scrollbar-track {
  background: transparent;
}

.sidenav::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.sidenav::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
</style>
